import React from 'react'
import { Button, makeStyles, Theme } from '@material-ui/core'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { ControlledTextField } from '../form/ControlledTextField'
import { ControlledDatePicker } from '../form/ControlledDatePicker'

const useStyles = makeStyles((theme: Theme) => ({
  form: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
  },
  control: {
    flexGrow: 1,
    margin: theme.spacing(2),
  },
}))

export type ProjectSearchFormValues = {
  keyword?: string
  createdAfter?: Date
}

type Props = {
  defaultValues: ProjectSearchFormValues
  onSubmit: (values: ProjectSearchFormValues) => void
  disabled: boolean
}

export function ProjectSearchForm({
  defaultValues,
  onSubmit,
  disabled,
}: Props): React.ReactElement {
  const classes = useStyles()
  const { control, handleSubmit, errors } = useForm<ProjectSearchFormValues>({
    defaultValues,
  })
  const { t } = useTranslation()

  return (
    <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
      <ControlledTextField
        className={classes.control}
        control={control}
        name="keyword"
        error={errors.keyword}
        label={t('projects.searchForm.keyword')}
        disabled={disabled}
        dataCy="projects-search-input"
      />

      <ControlledDatePicker
        className={classes.control}
        control={control}
        name="createdAfter"
        label={t('projects.searchForm.createdAfter')}
        clearable
        disabled={disabled}
        dataCy="projects-search-created-after"
      />

      <Button
        className={classes.control}
        type="submit"
        variant="contained"
        color="primary"
        disabled={disabled}
        data-cy="projects-search-submit"
      >
        {t('projects.searchForm.submit')}
      </Button>

      <Button
        className={classes.control}
        variant="contained"
        onClick={() => onSubmit({})}
        disabled={disabled}
        data-cy="projects-search-clear"
      >
        {t('common.clear')}
      </Button>
    </form>
  )
}
